import { FC } from 'react';
import { MARKS, BLOCKS } from '@contentful/rich-text-types';

import { CommonRichText } from 'components/Shared/SharedComponents';
import { RichTextParsersConfig } from 'types/objectTypes';
import classes from 'src/styles/_commonClasses.module.scss';
import {
  mapBlocksParagraphWithReplacement,
  mapBlocksSpanWithReplacement,
  mapBlocksUlListWithReplacement,
  mapMarksBoldWithReplacement,
} from 'lib/richTextMappers';
import { NormalizedNcOffer } from 'src/shared/lib/offers/offersTypes';

import styles from './DynamicModalWithStore.module.scss';

import { ChildProps } from '../config/declarations';

const getContentConfig = (
  dynamicData: NormalizedNcOffer | null,
): RichTextParsersConfig => {
  const possiblePrice = (dynamicData?.basePrice ?? Number.NaN)
    * (dynamicData?.purchaseMinutes ?? Number.NaN);
  const price = Number.isFinite(possiblePrice)
    ? possiblePrice.toFixed(2)
    : dynamicData?.amountToCredit?.toFixed(2) || '';
  const replacementObject = {
    credits: dynamicData?.amountToCredit?.toFixed(2) || '',
    totalMinutes: dynamicData?.totalMinutes?.toString() || '',
    price,
  };

  return ({
    [BLOCKS.UL_LIST]: {
      classNames: {
        ul: styles.list,
        li: styles.li,
      },
      mapper: mapBlocksUlListWithReplacement(replacementObject),
    },
    [BLOCKS.HEADING_2]: {
      classNames: styles.title,
    },
    [BLOCKS.PARAGRAPH]: {
      classNames: styles.textWrapper,
      mapper: mapBlocksParagraphWithReplacement(replacementObject),
    },
    [MARKS.BOLD]: {
      classNames: styles.text,
      mapper: mapMarksBoldWithReplacement(replacementObject),
    },
    [MARKS.UNDERLINE]: {
      classNames: styles.price,
      mapper: mapBlocksSpanWithReplacement(replacementObject),
    },
    [BLOCKS.HR]: {
      classNames: styles.hr,
    },
  });
};

const getTitleConfig = (dynamicData: NormalizedNcOffer | null): RichTextParsersConfig => {
  const replacementObject = { price: `${dynamicData?.basePrice?.toFixed(2) || ''}` };

  return ({
    [BLOCKS.HEADING_2]: {
      classNames: styles.title,
    },
    [BLOCKS.PARAGRAPH]: {
      classNames: styles.upperNote,
      mapper: mapBlocksParagraphWithReplacement(replacementObject),
    },
    [MARKS.BOLD]: {
      classNames: classes.textBold,
      mapper: mapMarksBoldWithReplacement(replacementObject),
    },
  });
};

export const OfferDetailsSection: FC<ChildProps> = ({
  block,
  dynamicData,
}) => {
  if (!block || !block.content) {
    return null;
  }

  return (
    <div className={styles.details}>
      <CommonRichText content={block.richTitle} parsersConfig={getTitleConfig(dynamicData)} />
      <CommonRichText content={block.content} parsersConfig={getContentConfig(dynamicData)} />
    </div>
  );
};
